//* 组件库
import type { UiForm, UiTypes } from "various-ui";
import { $loading, $message } from "various-ui";
//* 公共函数
import { Rules } from "@/assets/js";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态属性
    const vars: { types: { name: string; value: string }[] } = {
        types: [
            { name: i18n.t("ContactUs.NewFunction"), value: "New Fun" },
            { name: i18n.t("ContactUs.DataError"), value: "Data Error" },
            { name: i18n.t("ContactUs.CustomerExperience"), value: "User Experience" },
            { name: i18n.t("ContactUs.Others"), value: "Other" },
        ],
    };

    //* 表单数据
    const data = reactive({ type: vars.types[0].value, name: "", email: "", phone: "", comment: "" });
    //* 校验规则
    const rules: { [name: string]: UiTypes.verifyRule[] } = {
        name: [
            {
                trigger: "change",
                verify: (value: any) => {
                    return { verify: value.name, message: i18n.t("Layout.PleaseEnterYour", { name: "FullName" }) };
                },
            },
        ],
        phone: [
            {
                trigger: "change",
                verify: (value: any) => {
                    if (value.phone && !Rules.phone(value.phone)) {
                        return { verify: false, message: i18n.t("Layout.SuccessType", { name: "PhoneNumber" }) };
                    } else {
                        return { verify: true, message: "" };
                    }
                },
            },
        ],
        email: [
            {
                trigger: "change",
                verify: (value: any) => {
                    if (!value.email) {
                        return { verify: false, message: i18n.t("Layout.PleaseEnterYour", { name: "EmailAddress" }) };
                    } else if (!Rules.email(value.email)) {
                        return { verify: false, message: i18n.t("Layout.SuccessType", { name: "EmailAddress" }) };
                    } else {
                        return { verify: true, message: "" };
                    }
                },
            },
        ],
        comment: [
            {
                trigger: "change",
                verify: (value: any) => {
                    return { verify: value.comment, message: i18n.t("Layout.PleaseEnterYour", { name: "Suggestion" }) };
                },
            },
        ],
    };

    //* 节点
    const nodes = {
        form: ref<InstanceType<typeof UiForm>>(),
    };

    //* 函数列表
    const methods = {
        //* 校验类型更新
        type: (value: string) => (data.type = value),

        //* 表单提交
        submit: () => {
            $loading.open({ message: "" });
            nodes.form.value?.validator((valid) => {
                if (!valid) return $loading.close();
                api.frontend("/api/v1/contact-us/feedback", {
                    data: data,
                    method: "POST",
                    finally: () => $loading.close(),
                    success: () => {
                        $message({ icon: "success", type: "success", delay: 5000, message: i18n.t("ContactUs.Success") });
                        nodes.form.value?.reset();
                    },
                });
            });
        },
    };

    return { vars, data, rules, nodes, methods };
};
